import { FC } from 'react';
import { AgentModel } from '@/lib/models/agent.model';
import { Avatar, Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';
import { getFirstLastName } from '@/lib/helpers';
import classNames from 'classnames';
import OrgBadge from '../org-badge';

interface Props {
  agent?: AgentModel;
  size?: 'small' | 'medium';
}

const useStyles = createUseStyles((theme: Theme) => ({
  agentBadge: {
    backgroundColor: '#7ebd94',
    '&.small': {
      width: 24,
      height: 24,
      fontSize: '0.75rem',
    },
    '& img': {
      objectFit: 'fill',
    },
  },
  unavailableAgentBadge: {
    backgroundColor: theme.palette.grey[400],
    '&.small': {
      width: 24,
      height: 24,
      fontSize: '0.75rem',
    },
  },
}));

const AgentBadge: FC<Props> = ({ agent, size = 'medium' }) => {
  const styles = useStyles();

  if (!agent) {
    const compClass = classNames(styles.unavailableAgentBadge, size);
    return <Avatar className={compClass}></Avatar>;
  }

  const {
    isDefaultAgent,
    portal: { badge },
  } = agent;

  if (isDefaultAgent) {
    return <OrgBadge size={size} />;
  }

  const { image, title } = badge;
  const compClass = classNames(styles.agentBadge, size);

  if (image) {
    return <Avatar src={image} alt={title} className={compClass} />;
  }

  const { first, last } = getFirstLastName(title);
  const initials = `${first[0] || ''}${last[0] || ''}`.toUpperCase();

  return <Avatar className={compClass}>{initials}</Avatar>;
};

export default AgentBadge;
